<template>
  <v-card tile>
    <v-row class="ma-0">
      <v-card-title><h1>Package confirmation</h1></v-card-title>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="7" class="pa-2">
        <v-card-text class="pt-0 pl-2">
          <h2>
            {{ packageName }} -
            <span class="color--primary">{{ strapline }}</span>
          </h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <h2>Includes</h2>
          <v-row>
            <v-col
              cols="6"
              v-for="(sec, idx) in this.selectedPackage.includes"
              :key="idx"
            >
              <ul class="pl-4">
                <li v-for="txt in sec" :key="txt" class="text-section-title">
                  {{ txt }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
      <v-col cols="5" class="pa-2 pr-0">
        <button
          :disabled="loading"
          class="package-btn my-2"
          v-for="pkg in packages"
          :key="pkg.id"
          @click="selectedPackageId = pkg.id"
          :style="{
            background: pkg.id === selectedPackageId ? pkg.color : '#d5d5d5',
          }"
        >
          <v-container class="pa-0">
            <v-row class="pa-0 ma-0 px-2" align="center">
              <v-col cols="7" class="ma-0" align="start">
                <h2>{{ pkg.name }}</h2>
                <p class="ma-0">
                  <span class="price">{{ pkg.price }}</span> user / month
                </p>
              </v-col>
              <v-col cols="5" class="pa-0 ma-0">
                <v-row
                  class="free-trial pa-0 ma-0 px-2"
                  v-if="pkg.trial"
                  justify="center"
                  align="center"
                >
                  <h3>Free trial</h3>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </button>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="7" class="pa-2">
        <v-card-actions>
          <v-btn
            class="button-secondary"
            elevation="0"
            @click="goBack"
            :disabled="loading"
            >Change details</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="button-primary"
            elevation="0"
            @click="action"
            :loading="loading"
            >{{ actionButtonText }}</v-btn
          >
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { functions } from '@/firebaseConfig'
import { mapActions } from 'vuex'

export default {
  props: ['companyData'],
  data: () => ({
    loading: false,
    selectedPackageId: 'essential',
    packages: [
      {
        name: 'Essential',
        id: 'essential',
        includes: [
          ['Unlimited users', 'Projects', 'Jobs'],
          ['Clients', 'iOS and Android app'],
        ],
        price: '£5',
        trial: true,
        color: '#ffd057',
      },
      {
        name: 'Team',
        id: 'team',
        includes: [
          ['Unlimited users', 'Projects', 'Jobs', 'Clients'],
          ['Warehouse', 'Holidays', 'Reporting', 'iOS and Android app'],
        ],
        price: '£10',
        trial: true,
        color: '#00e8af',
      },
      {
        name: 'Corporate',
        id: 'corporate',
        includes: [
          ['Unlimited users', 'Projects', 'Jobs', 'Clients', 'Warehouse'],
          [
            'Holidays',
            'Reporting',
            'Business branded',
            'Custom subdomain',
            'iOS and Android app',
          ],
        ],
        price: '£15',
        trial: false,
        color: '#0093e8',
      },
    ],
  }),
  computed: {
    actionButtonText() {
      return this.selectedPackage.trial === true
        ? 'Confirm pacakge'
        : 'Get in touch'
    },
    packageName() {
      return this.selectedPackage.name
    },
    strapline() {
      if (this.selectedPackage.trial) {
        return '30 days free trial'
      } else {
        return 'Get in touch'
      }
    },
    selectedPackage() {
      return this.packages.filter((el) => el.id === this.selectedPackageId)[0]
    },
  },
  methods: {
    ...mapActions(['showError']),
    action() {
      if (this.selectedPackage.trial === true) {
        this.submit()
      } else {
        window.location.href = 'https://clickwork.app/corporate'
      }
    },
    goBack() {
      this.$emit('update:step', 3)
    },
    async submit() {
      this.loading = true
      try {
        const registerCompany = functions.httpsCallable('companies-register')

        const result = await registerCompany({
          packageID: this.selectedPackageId,
          ...this.companyData,
        })
        const company = result.data

        this.$store.commit('setCurrentCompany', company)
        // Load other company info
        await this.$store.dispatch('loadCompanyRelatedData')
        await this.$store.dispatch('getCurrentUserScopes')

        this.$router.replace({ name: 'home' })
      } catch (error) {
        this.showError(error.message ?? 'Unknown error, please try again later')
        console.error(error)
        this.loading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.package-btn
  width: 100%
  background: #d5d5d5
  min-height: 87px
  border-radius: 43px 0px 0px 43px

.free-trial
  background: $foreground
  min-height: 38px
  border-radius: 22px

.price
  @include price
</style>
